export default function matchQuery(size = 'md') {
  switch (size) {
    case 'sm':
      return window.matchMedia('(min-width: 640px)').matches;
    case 'md':
      return window.matchMedia('(min-width: 768px)').matches;
    case 'lg':
      return window.matchMedia('(min-width: 1024px)').matches;
    case 'xl':
      return window.matchMedia('(min-width: 1280px)').matches;
    default:
      return false;
  }
}
